/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Image_Export_Preview_Generating_LabelInputs */

const en_image_export_preview_generating_label = /** @type {(inputs: Image_Export_Preview_Generating_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generating...`)
};

const fr_image_export_preview_generating_label = /** @type {(inputs: Image_Export_Preview_Generating_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generation...`)
};

const de_image_export_preview_generating_label = /** @type {(inputs: Image_Export_Preview_Generating_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wird generiert...`)
};

const it_image_export_preview_generating_label = /** @type {(inputs: Image_Export_Preview_Generating_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generazione in corso...`)
};

const ru_image_export_preview_generating_label = /** @type {(inputs: Image_Export_Preview_Generating_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Генерация...`)
};

const es_image_export_preview_generating_label = /** @type {(inputs: Image_Export_Preview_Generating_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Generando...`)
};

const zh_cn2_image_export_preview_generating_label = /** @type {(inputs: Image_Export_Preview_Generating_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`正在生成...`)
};

const ja_image_export_preview_generating_label = /** @type {(inputs: Image_Export_Preview_Generating_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`生成中...`)
};

const hi_image_export_preview_generating_label = /** @type {(inputs: Image_Export_Preview_Generating_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`जनरेट हो रहा है...`)
};

const pt_pt2_image_export_preview_generating_label = /** @type {(inputs: Image_Export_Preview_Generating_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Gerando...`)
};

/**
* | output |
* | --- |
* | "Generating..." |
*
* @param {Image_Export_Preview_Generating_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const image_export_preview_generating_label = /** @type {((inputs?: Image_Export_Preview_Generating_LabelInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Image_Export_Preview_Generating_LabelInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_image_export_preview_generating_label(inputs)
	if (locale === "de") return de_image_export_preview_generating_label(inputs)
	if (locale === "it") return it_image_export_preview_generating_label(inputs)
	if (locale === "ru") return ru_image_export_preview_generating_label(inputs)
	if (locale === "es") return es_image_export_preview_generating_label(inputs)
	if (locale === "zh-CN") return zh_cn2_image_export_preview_generating_label(inputs)
	if (locale === "ja") return ja_image_export_preview_generating_label(inputs)
	if (locale === "hi") return hi_image_export_preview_generating_label(inputs)
	if (locale === "pt-PT") return pt_pt2_image_export_preview_generating_label(inputs)
	return en_image_export_preview_generating_label(inputs)
});